/**
 * Dynamic Product Info – selected variant label
 * Updates the "Selected item" block when variant selection changes (e.g. from variant picker).
 */
(function() {
  'use strict';

  function getVariantIncludesMap(sectionId, productId) {
    var scriptEl = document.getElementById('VariantIncludes-' + sectionId + '-' + productId);
    if (!scriptEl || !scriptEl.textContent) return {};
    try {
      var pairs = JSON.parse(scriptEl.textContent.trim());
      var map = {};
      if (Array.isArray(pairs)) {
        pairs.forEach(function(p) {
          if (p && p.includes) map[p.id] = p.includes;
        });
      }
      return map;
    } catch (e) {
      return {};
    }
  }

  function updateSelectedVariantLabel(event) {
    var data = event && event.data;
    if (!data || !data.sectionId || !data.productId || !data.variant) return;

    var el = document.getElementById('SelectedVariant-' + data.sectionId + '-' + data.productId);
    if (!el) return;

    var productTitle = el.getAttribute('data-product-title') || '';
    var variant = data.variant;
    var variantTitle = variant.title || '';
    var includesMap = getVariantIncludesMap(data.sectionId, data.productId);
    var includesText = variant.id && includesMap[variant.id] ? includesMap[variant.id] : '';
    var displayText = includesText || (productTitle ? productTitle + ': ' + variantTitle : variantTitle);

    var strong = el.querySelector('strong');
    if (strong) strong.textContent = displayText;
  }

  function init() {
    if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS && window.theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, updateSelectedVariantLabel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
